import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Content from './Content'
import Footer from './Footer'
import Header from './Header'
import Loading from './Loading'
import messages from './messages'

import './index.scss'

const Card = ({ children, className, isActionInProgress, actionMessage }: any) => (
  <section className={`card rounded-lg border border-gray-200 bg-white shadow ${className}`}>
    {!!isActionInProgress && (
      <div className="card__overlay">
        <Loading isLoading={true} loadingMessage={actionMessage} />
      </div>
    )}

    {children}
  </section>
)

Card.Content = Content
Card.Footer = Footer
Card.Header = Header
Card.Loading = Loading

Card.displayName = 'Card'

Card.propTypes = {
  actionMessage: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  isActionInProgress: PropTypes.bool
}

Card.defaultProps = {
  actionMessage: <FormattedMessage {...messages.loading} />,
  children: null,
  className: '',
  isActionInProgress: false
}

export default Card

export { default as Content } from './Content'
export { default as Header } from './Header'
export { default as Footer } from './Footer'
